import { formatToDateString } from '../../../utils/TimeUtil';

/**
 * @param {?string} dateString
 * @return {?string}
 */
export const formatDate = dateString => {
  if (dateString) {
    return formatToDateString(dateString, 'en-US', false);
  } else {
    return dateString;
  }
};
